import locationsConfig, {
    moduleName as locationsModuleName,
} from "./Locations/config";
import modulesConfig, {
    moduleName as modulesModuleName,
} from "./Modules/config";
import translateConfig, {
    moduleName as translateModuleName,
} from "./Translate/config";

import ProjectContext from "app/App/context";
import IConfig from "interfaces/IConfig";
import { registerModule } from "moduleConfig";
import { registerRoutings } from "rootRouting";
import { registerProjects } from "rootProjects";
import { permissionsType, routingType } from "types/configTypes";
import AsyncComponent from "ui/AsyncComponent";

export const moduleName = "Order";
export const project = "order";
export const url = `/order`;

const getConfig = (permissions: permissionsType, settings: any) => {
    const config: IConfig = {
        active: false,
        routing: [],
        url,
    };

    let routing: routingType = [];

    const routingChildrens = [];

    // register Location module
    const locationsModule = locationsConfig(permissions, url);
    if (locationsModule.config.active) {
        config.active = true;

        registerModule(locationsModuleName, locationsModule.config);
        routingChildrens.push(...locationsModule.routing);
    }

    // register Modules module
    const modulesModule = modulesConfig(permissions, url);
    if (modulesModule.config.active) {
        config.active = true;

        registerModule(modulesModuleName, modulesModule.config);
        routingChildrens.push(...modulesModule.routing);
    }

    //register Translate module
    const tr = translateConfig(permissions, url);
    if (tr.config.active) {
        registerModule(translateModuleName, tr.config);
        routingChildrens.push(...tr.routing);
        config.active = true;
    }

    if (routingChildrens.length > 0) {
        routing.push({
            path: url + "/*",
            children: routingChildrens,
            element: (
                <ProjectContext.Provider value={{ project, url }}>
                    <AsyncComponent path="Order/index" />{" "}
                </ProjectContext.Provider>
            ),
        });
    }

    if (config.active) {
        registerProjects([
            {
                id: project,
                name: "Order",
                icon: "qr_code_scanner",
                url: `${url}`,
                priority: 400,
            },
        ]);
    }

    if (routing.length > 0) {
        config.routing = routing.map((item) => item.path);
        registerRoutings(routing);
    }

    return config;
};

export default getConfig;
